import React from 'react';
import { string } from 'prop-types';

import css from './IconManufacturer.module.css';

const IconManufacturer = props => {
  const { className, rootClassName } = props;
  const classes = rootClassName || css.root;
  const combinedClasses = className ? `${classes} ${className}`.trim() : classes;

  return (
    <svg
      className={combinedClasses}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1L10.5 5.5L15.5 6.5L12 10L13 15L8 12.5L3 15L4 10L0.5 6.5L5.5 5.5L8 1Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconManufacturer.defaultProps = {
  className: null,
  rootClassName: null,
};

IconManufacturer.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconManufacturer;
